/** @format */

import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
  namespaced: true,
  state() {
    return {
      practices: {},
      allComplaints: [],
      allComplaintsCount: [],
      complaint: {},
      complaintTypeStats: [],
      subjectGroupStats: [],
      staffGroupStats: [],
      ageGroupStats: [],
      patientRelationshipGroupStats: [],
      complaintsAgainstPracticesStats: [],
    };
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
};
